import { Temporal } from 'temporal-polyfill';
import { plainDateToEpochMs } from '@utils/dates';

type DataPoint = {
  date: string;
};

const toDateString = (item: DataPoint | string): string =>
  typeof item === 'string' ? item : item.date;

export function calculateDataCountByDayOfWeek(
  data: DataPoint[] | string[]
): Record<number, number> {
  return data.reduce(
    (acc, item) => {
      // Temporal dayOfWeek is ISO 8601 (1=Mon…7=Sun); % 7 maps to Highcharts convention (0=Sun…6=Sat)
      const dayOfWeek =
        Temporal.PlainDate.from(toDateString(item)).dayOfWeek % 7;
      acc[dayOfWeek] = (acc[dayOfWeek] ?? 0) + 1;
      return acc;
    },
    {} as Record<number, number>
  );
}

export function calculateLatestDate(data: DataPoint[] | string[]): number {
  return Math.max(...data.map(item => plainDateToEpochMs(toDateString(item))));
}

export function calculateFirstDate(data: DataPoint[] | string[]): number {
  return Math.min(...data.map(item => plainDateToEpochMs(toDateString(item))));
}
